import { IDispatcherService, IDispatcher, ILayoutActionCreatorService } from '../';

export interface ILayoutStoreService {
    setEditMode: (isEditMode: boolean) => angular.IPromise<void>;
    setMobileMode: (isMobileMode: boolean) => angular.IPromise<void>;
}

export interface ILayoutActionDispatcherService extends IDispatcherService<ILayoutStoreService> { }

export class LayoutActionDispatcherService implements ILayoutActionDispatcherService {
    static serviceId = 'layoutActionDispatcherService';

    static $inject = ['layoutActionCreatorService'];

    constructor(private _actionService: ILayoutActionCreatorService) { }

    getDispatcher(dispatch: Function): IDispatcher<ILayoutStoreService> {
        const as = this._actionService;

        return {
            dispatcher: {
                setEditMode: (b: boolean) => dispatch(as.setEditMode(b)),
                setMobileMode: (b: boolean) => dispatch(as.setMobileMode(b))
            }
        };
    }
}